import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyContractDurationComponent} from './contract-duration.component';
import {FormlyModule} from '@ngx-formly/core';
import {I18nModule} from '@spartacus/core';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
  imports: [
    I18nModule,
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'contract-duration',
          component: FormlyContractDurationComponent,
        },
      ],
    }),
    ReactiveFormsModule,
    FormlyContractDurationComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FormlyContractDurationModule {}
